import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "action-list" }

import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onActivated, ref } from 'vue'
import { useStore } from '@/store/index'
import Pagination from '@/components/Pagination.vue'
import { getWorkorderListApi } from '../../apis/workorder'
import { WorkorderType, WorkorderStatus, WorkorderApplyStatus, WorkorderLevel } from '../../enums/workorder'
import { millisecondFormat } from '../../utils/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkOrderList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore()
const filters = reactive({
    order_no: '', // 订单号
    work_type: '', // 工单类型
    work_level: '', // 工单优先级
    status: '', // 工单状态
    reply_status: '', // 申请状态
    page: 1,  // 当前页码
    page_size: 10, // 每页显示条数
})
const tableData = ref([])
const total = ref(0)
const getList = () => {
    getWorkorderListApi(filters).then((res:any) => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        // data.data.map((item:any) => item.countDown = getCountDown(item))
        tableData.value = data.data
        total.value = data.total
    })
}

// 罚款行标红
const rowClass = ({row, rowIndex}) => {
    if (row.fine_status == 1) {
        return 'error-row'
    }
}

// 计算倒计时
const getCountDown = (row:any) => {
    const { status, reply_status, work_reply_time, reject_time } = row
    /**
     * 工单状态已处理/已完结/已超时直接返回 “--”
     * 工单状态处理中进行计算
     *      根据 work_reply_time 判断倒计时
    */
    if (WorkorderStatus[status] === '待处理' || WorkorderStatus[status] === '处理中') {
        return millisecondFormat(new Date(work_reply_time).getTime() - Date.now()) 
    } else {
        return '--'
    }
}

const onSearch = () => {
    filters.page = 1
    getList()
}
// 跳转至编辑页
const toEdit = (row, t) => {
    router.push(`/merchant-admin/workorder-edit?id=${row.id}`)
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onActivated(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.order_no) = $event)),
        placeholder: "订单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.work_type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.work_type) = $event)),
        placeholder: "工单类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "客户投诉",
            value: _unref(WorkorderType)['客户投诉']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "客户咨询",
            value: _unref(WorkorderType)['客户咨询']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "门店咨询",
            value: _unref(WorkorderType)['门店咨询']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "其它",
            value: _unref(WorkorderType)['其它']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.work_level,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.work_level) = $event)),
        placeholder: "优先级",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "紧急",
            value: _unref(WorkorderLevel)['紧急']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "正常",
            value: _unref(WorkorderLevel)['正常']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.status) = $event)),
        placeholder: "工单状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待处理",
            value: _unref(WorkorderStatus)['待处理']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "处理中",
            value: _unref(WorkorderStatus)['处理中']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "已处理",
            value: _unref(WorkorderStatus)['已处理']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "已完结",
            value: _unref(WorkorderStatus)['已完结']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "已超时",
            value: _unref(WorkorderStatus)['已超时']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.reply_status,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.reply_status) = $event)),
        placeholder: "延期申请状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "未申请",
            value: _unref(WorkorderApplyStatus)['未申请']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "已申请",
            value: _unref(WorkorderApplyStatus)['已申请']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "申请通过",
            value: _unref(WorkorderApplyStatus)['申请通过']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "申请驳回",
            value: _unref(WorkorderApplyStatus)['申请驳回']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: "",
      "row-class-name": rowClass
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "订单号"
        }),
        _createVNode(_component_el_table_column, { label: "优先级" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_unref(WorkorderLevel)[scope.row.work_level]), 1),
              _createElementVNode("p", null, _toDisplayString(`回复时间：${_unref(WorkorderLevel)[scope.row.work_level] === '紧急' ? 10 :30 }分钟`), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "工单类型",
          width: "75"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(WorkorderType)[scope.row.type_id]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "工单状态",
          width: "75"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(WorkorderStatus)[scope.row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "申请状态",
          width: "75"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(WorkorderApplyStatus)[scope.row.reply_status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "work_created_at",
          label: "工单发起时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "work_reply_time",
          label: "最晚回复时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "work_content",
          label: "内容"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", {
              innerHTML: scope.row.work_content
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "75"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toEdit(scope.row, 'edit'))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("编辑")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"])
  ]))
}
}

})